<template>
    <div class="game-winner-tile__skeleton" />
</template>

<style lang="scss" scoped>
.game-winner-tile {
    &__skeleton {
        display: flex;
        position: relative;
        width: 100%;
        height: 100%;
        min-height: 58px;
        margin-bottom: 10px;
        border-radius: $game-tile-border-radius;
        background: $skeleton-color;
        overflow: hidden;
        min-width: 137px;
        margin-right: 10px;

        &::after {
            display: block;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            transform: translate3d(-100%, 0, 0);
            background-image: linear-gradient(90deg, transparent 0, $skeleton-loader-color 50%, transparent 100%);
            background-repeat: no-repeat;
            background-size: 300px;
            content: '';
            animation: skeleton-load 1.5s ease-in-out infinite;
        }
    }

    @keyframes skeleton-load {
        to {
            transform: translate3d(100%, 0, 0);
        }
    }
}
</style>
